import { render } from "./loadingRing.vue?vue&type=template&id=24bc7a08&scoped=true&ts=true"
import script from "./loadingRing.vue?vue&type=script&lang=ts"
export * from "./loadingRing.vue?vue&type=script&lang=ts"

import "./loadingRing.vue?vue&type=style&index=0&id=24bc7a08&lang=scss&scoped=true"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bc7a08"]])

export default __exports__